import { CustomColumn } from '../../types/customColumn';

import { TaxpayerCertificate } from '../../types/hacienda/TaxpayerCertificateTypes';

export const taxpayerCertificateColumns: CustomColumn<TaxpayerCertificate>[] = [
  {
    Header: 'Tipo de Archivo',
    accessor: 'fileTypeLabel',
    customCell: ({ row }) => (
      <div className="text-sm font-medium text-black dark:text-white">
        {row.original.fileTypeLabel}
      </div>
    ),
  },
  {
    Header: 'Nombre del Archivo',
    accessor: 'fileName',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.fileName}
      </span>
    ),
  },
  {
    Header: 'Ruta del Archivo',
    accessor: 'path',
    customCell: ({ row }) => (
      <span className="text-gray-500 dark:text-gray-400 text-sm">
        {row.original.path}
      </span>
    ),
  },
  {
    Header: 'Fecha de Carga',
    accessor: 'uploadedAt',
    customCell: ({ row }) => (
      <span className="text-gray-500 dark:text-gray-400 text-sm">
        {row.original.uploadedAt}
      </span>
    ),
  },
];
